import { Link } from 'react-router-dom'
import { useAccess, homeRouteLabel } from '@/shared/rbac'

export function ForbiddenPage() {
  const { homeRoute } = useAccess()
  const label = homeRouteLabel(homeRoute)

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        gap: 'var(--sp-4)',
        background: 'var(--bg)',
      }}
    >
      <span
        className="text-display"
        style={{ color: 'var(--danger)', fontFamily: 'var(--font-mono)' }}
      >
        403
      </span>
      <p className="text-h3">This page isn't available for your role</p>
      <Link to={homeRoute} className="btn btn-primary btn-md" style={{ marginTop: 'var(--sp-4)' }}>
        Take me to {label}
      </Link>
    </div>
  )
}
